import type { CustomCellRendererProps } from '@cmg/data-grid';
import { EditIcon, IconButton } from '@cmg/design-system';
import { useCallback } from 'react';

import type { FirmsInvestorContactsGridContext } from '../FirmsInvestorContactsGrid.model';
import type { FirmInvestorContactsGridItemFragment } from '../graphql/__generated__';

export function EditActionCellRenderer({
  data,
  context,
}: Readonly<
  CustomCellRendererProps<
    FirmInvestorContactsGridItemFragment,
    unknown,
    FirmsInvestorContactsGridContext
  >
>) {
  const handleEditContact = useCallback(() => {
    if (!data) {
      return;
    }
    context.onEditInvestorContact(data);
  }, [context, data]);

  return (
    <IconButton
      size="small"
      color="primary"
      disabled={!data}
      onClick={handleEditContact}
      aria-label="Edit Contact"
    >
      <EditIcon fontSize="small" />
    </IconButton>
  );
}
